module.exports = __webpack_public_path__ + "static/300x250-e6832f049460b7a70df7a1d00cca8d1d.jpg";